// 数据上报
import fetch from "@/utils/ajax";
import { getStoreUuid, getUgid } from "@/utils/tool";

export function dataAcq(data: any) {
  try {
    fetch
      .post(
        `/sea/v1/metrics?zuid=${encodeURI(
          getStoreUuid()
        )}&appid=jk&t=${getUgid()}&u=12329&c=2&b=300&bl=en_US`,
        data
      )
      .then(res => {});
  } catch (e) {
    console.log(e);
  }
}
